export default "__VITE_ASSET__$sXi9UyB__"